import clsx from "clsx";
import React from "react";
import type { DetailData } from "../../../../../contexts/chat-log/chat-log-context";
import styles from "./styles.module.scss";
import { isDirectNavigationLink } from "../../../../../libs/fns";
// import { useGSAP } from "@gsap/react";
// import { lineAnimation } from "./fns";

// Skeleton loading component
const Skeleton = () => (
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
      backgroundSize: "200% 100%",
      animation: "skeleton-loading 1.5s ease-in-out infinite",
    }}
  />
);

export default function Video({
  className,
  file_path,
  file_name,
  thumbnail,
  link,
  ...props
}: Omit<React.ComponentPropsWithoutRef<"div">, "children"> &
  Pick<DetailData, "file_path" | "file_name" | "thumbnail" | "link">) {
  const container = React.useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [showAnimation, setShowAnimation] = React.useState(true);

  // useGSAP(
  //   () => {
  //     lineAnimation();
  //   },
  //   { scope: container }
  // );

  React.useEffect(() => {
    // Simulate 3 seconds loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // 2秒后隐藏动画
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    if (link && isDirectNavigationLink(link)) {
      window.location.href = link;
    } else if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <style>{`
        @keyframes whiteFlash {
          0%, 100% {
            border-color: rgba(200, 230, 255, 1);
            box-shadow: 0 0 15px rgba(100, 180, 255, 1), 
                        0 0 30px rgba(150, 210, 255, 1),
                        0 0 45px rgba(180, 220, 255, 0.9),
                        0 0 60px rgba(200, 230, 255, 0.7),
                        inset 0 0 15px rgba(180, 220, 255, 0.8);
          }
          50% {
            border-color: rgba(220, 240, 255, 0.4);
            box-shadow: 0 0 8px rgba(150, 200, 255, 0.6), 
                        0 0 15px rgba(180, 220, 255, 0.5),
                        0 0 22px rgba(200, 230, 255, 0.4),
                        0 0 30px rgba(220, 240, 255, 0.3),
                        inset 0 0 8px rgba(200, 230, 255, 0.4);
          }
        }
        .white-flash-border-video {
          animation: whiteFlash 1.5s ease-in-out infinite;
        }
      `}</style>
      <div
        className={clsx(styles.wrap, link && styles.clickable, showAnimation && 'white-flash-border-video', className)}
        {...props}
        ref={container}
        onClick={handleClick}
        style={{
          cursor: link ? "pointer" : "default",
          width: "200px",
          height: "200px",
          minWidth: "200px",
          maxWidth: "200px",
          flexShrink: 0,
          position: "relative",
          overflow: "hidden",
          boxSizing: "border-box",
          border: showAnimation ? "4px solid rgba(200, 230, 255, 1)" : "1px solid #d0d0d0",
          borderRadius: "12px",
          isolation: "isolate",
          willChange: "auto",
          transform: "translateZ(0)",
          backfaceVisibility: "hidden",
          contain: "layout style paint"
        }}
      >
        <div
          className={styles.content}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            borderRadius: "12px"
          }}
        >
          {isLoading ? (
            <Skeleton />
          ) : (
            <video
              src={file_path}
              poster={thumbnail}
              controls
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px"
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}
